import Base from './Base';
import Case from './Case';

export default class PatientRecordDetails extends Base {
  description;
  id;
  imageCount;
  case;
  isAbleToViewRecord;
  type;
  title;

  constructor(source) {
    super();
    this.clone(source);
    this.title = source?.title || this.case?.study || this.description;
    this.case = this.case ? new Case(this.case) : null;
    this.createdAt = this.createdAt ? new Date(this.createdAt) : null;
  }

  get status() {
    if (!this.case) {
      return null;
    }
    if (this.case?.status?.value === 'completed') {
      return 'completed';
    }

    if (this.case?.status?.value === 'not-paid') {
      return 'not-paid';
    }

    return 'in-progress';
  }
}
